import DashboardLayout from "../../../Components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../Components/Navbars/DashboardNavbar";
import MDBox from "../../../Components/MDBox";
import {useFormik} from "formik";
import {ButtonBase, Grid, TableBody, TableContainer, TableHead, TableRow} from "@mui/material";
import MDTypography from "../../../Components/MDTypography";
import {setLoading, useMaterialUIController} from "../../../Context/mui";
import React, {useLayoutEffect, useState} from "react";
import theme from "../../../Asset/theme";
import MDDate from "../../../Components/MDDate";
import MDInput from "../../../Components/MDInput";
import MDSelect from "../../../Components/MDSelect";
import * as yup from "yup";
import {UserModel} from "../../../Api/Model/UserModel";
import Cookies from "js-cookie";
import {ErrorToaast, SuccessToaast} from "../../../utils/toast/Toast";
import {useParams} from "react-router-dom";
import {toast} from "react-toastify";
import {CurrentUser} from "../../../utils/Hooks/currentUser";
import Paper from "@mui/material/Paper";
import {Table} from "reactstrap";
import MDTableCell from "../../../Components/MDTable/MDTableCell";

const getValidationSchema = (role) => {
    let general = yup.object({
        name: yup.string().required("نام الزامی است"),
        lastName: yup.string().required("نام خانوادگی الزامی است"),
        sex: yup.string().required("جنسیت الزامی است"),
        Birthday: yup.date().required("تاریخ تولد الزامی است"),
        CodeMeli: yup.string().required("کد ملی الزامی است"),

    })
    let Pezeshk = yup.object({
        Takhasos: yup.string().required("تخصص الزامی است"),

    })
    let ParentSudent = yup.object({
        BirthCity: yup.string().required("محل تولد الزامی است"),
        FatherName: yup.string().required("نام پدر الزامی است"),
        PhoneNumber: yup.string().required("شماره تلفن الزامی است"),
        SathTahsilat: yup.string().required("سطح تحصیلات الزامی است"),
        MaghTahsilat: yup.string().required("مقطع تحصیلات الزامی است"),

    })
    let Morabi = yup.object({
        ReshteTahsili: yup.string().required("رشته تحصیلی الزامی است"),
        SabgheShoghli: yup.string().required("سابقه شغلی الزامی است"),

    })
    let others = yup.object({
        NoeBime: yup.string().required("نوع بیمه الزامی است"),
        Boomi: yup.string().required("وضعیت بومی الزامی است"),
        MotherName: yup.string().required("نام مادر الزامی است"),
        MotherJob: yup.string().required("شغل مادر الزامی است"),
        FatherJob: yup.string().required("شغل پدر الزامی است"),
        ParentStatus: yup.string().required("وضعیت زندگی والدین الزامی است"),
        Mazhab: yup.string().required("مذهب الزامی است"),
        NoeSchoole: yup.string().required("نوع مدرسه الزامی است"),
        PayeThsili: yup.string().required("پایه تحصیلی الزامی است"),
        CityTahsil: yup.string().required("شهر محل تحصیل الزامی است"),
        TaradodMadrse: yup.string().required("وضعیت تردد به مدرسه الزامی است"),
        DateSchool: yup.date().required("تاریخ ورود به مدرسه الزامی است"),
        ShomSkoonat: yup.string().required("شماره محل سکونت الزامی است"),
        AddressSkoonat: yup.string().required("آدرس محل سکونت الزامی است"),
    })
    let all = general;
    if (role === "Pezeshk") {
        all = all.concat(Pezeshk)
    }
    if (role === "Morabi") {
        all = all.concat(Morabi)
    }
    if (role === "Student") {
        all = all.concat(others)
    }
    if (role === "Parent") {
        all = all.concat(ParentSudent)
    }

    return all
};
export default function StudentInformation() {
    const [controller, dispatch] = useMaterialUIController();
    const [isNew, setIsnew] = useState(true)
    const [bmiWarn, setIsBmiWarn] = useState(false)
    const [studentShowMedalDialog, setStudentShowMedalDialog] = useState({open: false, model: null});

    const {loading} = controller;

    var Api = new UserModel(Cookies.get("cst") ?? "");

    const formik = useFormik({
        initialValues: {
            name: "",
            lastName: "",
            NoeBime: "",
            sex: "",
            Birthday: "",
            BirthCity: "",
            Boomi: "",
            PhoneNumber: "",
            FatherName: "",
            MotherName: "",
            MotherJob: "",
            FatherJob: "",
            ParentStatus: "",
            Mazhab: "",
            CodeMeli: "",
            NoeSchoole: "",
            PayeThsili: "",
            CityTahsil: "",
            TaradodMadrse: "",
            Takhasos: "",
            ReshteTahsili: "",
            SathTahsilat: "",
            MaghTahsilat: "",
            SabgheShoghli: "",
            DateSchool: "",
            ShomSkoonat: "",
            AddressSkoonat: ""
        },
        onSubmit: (values) => {
            setLoading(dispatch, true);
            Api.UpdateInformation({
                name: values.name,
                lastName: values.lastName,
                NoeBime: values.NoeBime,
                sex: values.sex?.toString(),
                Birthday: values.Birthday,
                BirthCity: values?.BirthCity,
                Boomi: values.Boomi?.toString(),
                PhoneNumber: values.PhoneNumber?.toString(),
                FatherName: values.FatherName,
                MotherName: values.MotherName,
                MotherJob: values.MotherJob,
                FatherJob: values.FatherJob,
                Takhasos: values.Takhasos,
                ReshteTahsili: values.ReshteTahsili,
                SathTahsilat: values.SathTahsilat,
                MaghTahsilat: values.MaghTahsilat,
                SabgheShoghli: values.SabgheShoghli,
                ParentStatus: values.ParentStatus?.toString(),
                Mazhab: values.Mazhab,
                CodeMeli: values.CodeMeli,
                NoeSchoole: values.NoeSchoole,
                PayeThsili: values.PayeThsili,
                CityTahsil: values.CityTahsil,
                TaradodMadrse: values.TaradodMadrse,
                DateSchool: values.DateSchool,
                ShomSkoonat: values.ShomSkoonat?.toString(),
                AddressSkoonat: values.AddressSkoonat
            })
                .then(response => {
                    setLoading(dispatch, false)
                    SuccessToaast("با موفقیت ویرایش شد")
                })
                .catch(error => {
                    ErrorToaast("خطا در ثبت اطلاعات");
                    setLoading(dispatch, false);
                });
        },

        validationSchema: getValidationSchema(CurrentUser()?.Role)
    })
    useLayoutEffect(() => {

        setLoading(dispatch, true)
        Api.Information()
            .then(r => {
                if (r.data.data !== null) {
                    setIsnew(false)
                    let model = r.data.data;
                    formik.setValues({
                        name: model.name,
                        lastName: model.lastName,
                        NoeBime: model.noeBime,
                        sex: model.sex,
                        Birthday: model.birthday,
                        BirthCity: model.birthCity,
                        Boomi: model.boomi,
                        PhoneNumber: model.phoneNumber,
                        Takhasos: model.takhasos,
                        ReshteTahsili: model.reshteTahsili,
                        SathTahsilat: model.sathTahsilat,
                        MaghTahsilat: model.maghTahsilat,
                        SabgheShoghli: model.sabgheShoghli,
                        FatherName: model.fatherName,
                        MotherName: model.motherName,
                        MotherJob: model.motherJob,
                        FatherJob: model.fatherJob,
                        ParentStatus: model.parentStatus,
                        Mazhab: model.mazhab,
                        CodeMeli: model.codeMeli,
                        NoeSchoole: model.noeSchoole,
                        PayeThsili: model.payeThsili,
                        CityTahsil: model.cityTahsil,
                        TaradodMadrse: model.taradodMadrse,
                        DateSchool: model.dateSchool,
                        ShomSkoonat: model.shomSkoonat,
                        AddressSkoonat: model.addressSkoonat

                    })
                    setIsBmiWarn(model?.isBmi);

                }
                setLoading(dispatch, false)
            })
            .then(() => {
                Api
                    .GetMedal(CurrentUser()?.user.id)
                    .then((r) => {
                        setStudentShowMedalDialog({model: r.data.data, open: true})
                    })
                    .catch(() => {
                        ErrorToaast("خطا در دریافت اطلاعات")
                    });
            })
            .catch(r => {

                ErrorToaast("دریافت اطلاعات با مشکل مواجه شد")
                setLoading(dispatch, false)

            })

    }, [])

    return <DashboardLayout>

        <DashboardNavbar name={"اطلاعات فردی"}>
            ثبت مشخصات فردی
        </DashboardNavbar>

        {bmiWarn && (
            <MDBox py={3} bgColor="#ffdbdb" border={"1px solid red"} p={1} mb={2} flex={1} borderRadius={2}
                   style={{overflowX: "auto", borderRadius: "10px"}}>
                <MDTypography fontWeight={"bold"} sx={{color: "darkblue"}}>
                    شما اخطار BMI دارید لطفا با پزشک خود در ارتباط <باشید className=""></باشید>
                    شما اخطار BMI دارید لطفا با پزشک خود در ارتباط  باشید
                </MDTypography>
            </MDBox>)
        }
        <MDBox py={3} bgColor="#fff" p={2} mb={2} flex={1} borderRadius={2} style={{overflowX: "auto"}}>
            <Grid container justifyContent={"center"} wrap="nowrap">

                <Grid container>
                    {studentShowMedalDialog?.model?.map((group, index) => (
                        <Grid item container key={index} spacing={2} mb={1}>
                            <Grid item xs={12}>
                                <MDTypography variant="h6">{group.title}</MDTypography>
                            </Grid>
                            <Grid item xs={12}>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <MDTableCell>نوع مدال</MDTableCell>
                                                <MDTableCell>تاریخ اهدا</MDTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {group.medals.map((medal, idx) => (
                                                <TableRow key={idx}>
                                                    <MDTableCell>
                                                        {medal.medalType === 0 && "طلا"}
                                                        {medal.medalType === 0 && (<img height={30} width={30}
                                                                                        src={require('../../../Asset/images/medal1.png')}/>)}
                                                        {medal.medalType === 1 && "نقره"}
                                                        {medal.medalType === 1 && (<img height={30} width={30}
                                                                                        src={require('../../../Asset/images/medal2.png')}/>)}
                                                        {medal.medalType === 2 && "برنز"}
                                                        {medal.medalType === 2 && (<img height={30} width={30}
                                                                                        src={require('../../../Asset/images/medal3.png')}/>)}
                                                        {medal.medalType === 3 && "ویژه"}
                                                        {medal.medalType === 3 && (<img height={30} width={30}
                                                                                        src={require('../../../Asset/images/medal4.png')}/>)}
                                                    </MDTableCell>
                                                    <MDTableCell>
                                                        {new Date(medal.modified).toLocaleString('fa-IR')}
                                                    </MDTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Grid>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
        </MDBox>
        <MDBox mx={{xs: 2, md: 10, lg: 10}} mt={4} component="form" role="form" onSubmit={formik.handleSubmit}>
            <Grid container rowSpacing={5} borderBottom={"1px solid #477B04"} py={4}>
                <Grid container item spacing={4}>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="name"
                            name="name"
                            value={formik.values.name}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.name)
                            }
                            helperText={formik.errors.name}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"نام"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="lastName"
                            name="lastName"
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.lastName)
                            }
                            helperText={formik.errors.lastName}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"نام خانوادگی"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="CodeMeli"
                            type={"number"}
                            name="CodeMeli"
                            value={formik.values.CodeMeli}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.CodeMeli)
                            }
                            helperText={formik.errors.CodeMeli}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"کد ملی"}/>
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDDate
                            name="Birthday"
                            onChange={(r) =>
                                formik.setFieldValue("Birthday", r)
                            }
                            defaultValue={formik.values.Birthday}
                            label={("تاریخ تولد")}
                            error={
                                Boolean(formik.errors.Birthday)
                            }
                            portal
                            helperText={
                                formik.errors.Birthday
                            }
                            w={{xs: "100%", md: "100%", lg: "90%",}}

                            disabled={loading}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <MDSelect
                            id="sex"
                            name="sex"
                            value={formik.values.sex}
                            onChange={(r) => formik.setFieldValue("sex", r)}
                            error={
                                Boolean(formik.errors.sex)
                            }
                            helperText={formik.errors.sex}
                            autoComplete={"1"}
                            disabled={loading}
                            w={{xs: "100%", md: "100%", lg: "90%",}}
                            label={"جنسیت"}>
                            <option value={"زن"}>زن</option>
                            <option value={"مرد"}>مرد</option>


                        </MDSelect>
                    </Grid>
                    {CurrentUser()?.Role === "Pezeshk" &&
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="Takhasos"
                                name="Takhasos"
                                value={formik.values.Takhasos}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.Takhasos)
                                }
                                helperText={formik.errors.Takhasos}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"تخصص"}/>
                        </Grid>
                    }

                    {CurrentUser()?.Role === "Morabi" && <>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="ReshteTahsili"
                                name="ReshteTahsili"
                                value={formik.values.ReshteTahsili}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.ReshteTahsili)
                                }
                                helperText={formik.errors.ReshteTahsili}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"رشته تحصیلی"}/>
                        </Grid> <
                        Grid item xs={12} md={6} lg={3}>
                        <MDInput
                            id="SabgheShoghli"
                            name="SabgheShoghli"
                            value={formik.values.SabgheShoghli}
                            onChange={formik.handleChange}
                            error={
                                Boolean(formik.errors.SabgheShoghli)
                            }
                            helperText={formik.errors.SabgheShoghli}
                            autoComplete={"1"}
                            disabled={loading}
                            width={"200px"}
                            sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                            label={"سابقه شغلی"}/>
                    </Grid>
                    </>
                    }
                    {(CurrentUser()?.Role === "Student" || CurrentUser()?.Role === "Parent") && <>

                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="BirthCity"
                                name="BirthCity"
                                value={formik.values.BirthCity}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.BirthCity)
                                }
                                helperText={formik.errors.BirthCity}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"محل تولد"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="FatherName"
                                name="FatherName"
                                value={formik.values.FatherName}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.FatherName)
                                }
                                helperText={formik.errors.FatherName}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"نام پدر"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="PhoneNumber"
                                name="PhoneNumber"
                                type={"number"}

                                value={formik.values.PhoneNumber}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.PhoneNumber)
                                }
                                helperText={formik.errors.PhoneNumber}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"شماره تلفن"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDSelect
                                id="SathTahsilat"
                                name="SathTahsilat"
                                value={formik.values.SathTahsilat}
                                onChange={(r) => formik.setFieldValue("SathTahsilat", r)}
                                error={
                                    Boolean(formik.errors.SathTahsilat)
                                }
                                helperText={formik.errors.SathTahsilat}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "90%",}}
                                label={"سطح تحصیلات"}>
                                <option value={"دبستانی"}>دبستانی</option>
                                <option value={" دوره متوسطه اول"}> دوره متوسطه اول</option>
                                <option value={" دوره متوسطه دوم"}> دوره متوسطه دوم</option>


                            </MDSelect>

                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDSelect
                                id="MaghTahsilat"
                                name="MaghTahsilat"
                                value={formik.values.MaghTahsilat}
                                onChange={(r) => formik.setFieldValue("MaghTahsilat", r)}
                                error={
                                    Boolean(formik.errors.MaghTahsilat)
                                }
                                helperText={formik.errors.MaghTahsilat}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "90%",}}
                                label={"مقطع تحصیلات"}>
                                <option value={"پایه اول"}> پایه اول</option>
                                <option value={"پایه دوم"}>پایه دوم</option>
                                <option value={"پایه سوم"}>پایه سوم</option>
                                <option value={"پایه چهارم"}>پایه چهارم</option>
                                <option value={"پایه پنجم"}>پایه پنجم</option>
                                <option value={"پایه ششم"}>پایه ششم</option>
                                <option value={"پایه هفتم"}>پایه هفتم</option>
                                <option value={"پایه هشتم"}>پایه هشتم</option>
                                <option value={"پایه نهم"}>پایه نهم</option>
                                <option value={"پایه دهم"}>پایه دهم</option>
                                <option value={"پایه یازدهم"}>پایه یازدهم</option>
                                <option value={"پایه دوازدهم"}>پایه دوازدهم</option>


                            </MDSelect>

                        </Grid>
                    </>
                    }
                    {CurrentUser()?.Role === "Student" && <>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="NoeBime"
                                name="NoeBime"
                                value={formik.values.NoeBime}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.NoeBime)
                                }
                                helperText={formik.errors.NoeBime}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"نوع بیمه"}/>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                            <MDSelect
                                id="Boomi"
                                name="Boomi"
                                value={formik.values.Boomi}
                                onChange={(r) => formik.setFieldValue("Boomi", r)}
                                error={
                                    Boolean(formik.errors.Boomi)
                                }
                                helperText={formik.errors.Boomi}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "90%",}}
                                label={"وضعیت بومی"}>
                                <option value={"بومی"}>بومی</option>
                                <option value={"غیر بومی"}>غیر بومی</option>


                            </MDSelect>
                        </Grid>


                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="MotherName"
                                name="MotherName"
                                value={formik.values.MotherName}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.MotherName)
                                }
                                helperText={formik.errors.MotherName}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"نام مادر"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="MotherJob"
                                name="MotherJob"
                                value={formik.values.MotherJob}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.MotherJob)
                                }
                                helperText={formik.errors.MotherJob}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"شغل مادر"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="FatherJob"
                                name="FatherJob"
                                value={formik.values.FatherJob}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.FatherJob)
                                }
                                helperText={formik.errors.FatherJob}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"شغل پدر"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDSelect
                                id="ParentStatus"
                                name="ParentStatus"
                                value={formik.values.ParentStatus}
                                onChange={(r) => formik.setFieldValue("ParentStatus", r)}
                                error={
                                    Boolean(formik.errors.ParentStatus)
                                }
                                helperText={formik.errors.ParentStatus}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "90%",}}
                                label={"وضعیت زندگی والدین"}>
                                <option value={"مشترک"}>مشترک</option>
                                <option value={"متارکه"}>متارکه</option>


                            </MDSelect>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="Mazhab"
                                name="Mazhab"
                                value={formik.values.Mazhab}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.Mazhab)
                                }
                                helperText={formik.errors.Mazhab}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"مذهب"}/>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                            <MDSelect
                                id="NoeSchoole"
                                name="NoeSchoole"
                                value={formik.values.NoeSchoole}
                                onChange={(r) => formik.setFieldValue("NoeSchoole", r)}
                                error={
                                    Boolean(formik.errors.NoeSchoole)
                                }
                                helperText={formik.errors.NoeSchoole}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "90%",}}
                                label={"نوع مدرسه"}>
                                <option value={"غیرانتفاعی"}>غیرانتفاعی</option>
                                <option value={"دولتی"}>دولتی</option>


                            </MDSelect>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="PayeThsili"
                                name="PayeThsili"
                                value={formik.values.PayeThsili}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.PayeThsili)
                                }
                                helperText={formik.errors.PayeThsili}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"پایه تحصیلی"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="CityTahsil"
                                name="CityTahsil"
                                value={formik.values.CityTahsil}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.CityTahsil)
                                }
                                helperText={formik.errors.CityTahsil}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"شهر محل تحصیل"}/>
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDSelect
                                id="TaradodMadrse"
                                name="TaradodMadrse"
                                value={formik.values.TaradodMadrse}
                                onChange={(r) => formik.setFieldValue("TaradodMadrse", r)}
                                error={
                                    Boolean(formik.errors.TaradodMadrse)
                                }
                                helperText={formik.errors.TaradodMadrse}
                                autoComplete={"1"}
                                disabled={loading}
                                w={{xs: "100%", md: "100%", lg: "90%",}}
                                label={"وضعیت تردد به مدرسه"}>
                                <option value={"پیاده روی"}>پیاده روی</option>
                                <option value={"سرویس مدرسه"}>سرویس مدرسه</option>
                                <option value={"وسیله شخصی"}>وسیله شخصی</option>
                                <option value={"حمل و نقل عمومی "}>حمل و نقل عمومی</option>


                            </MDSelect>

                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDDate
                                name="DateSchool"
                                onChange={(r) =>
                                    formik.setFieldValue("DateSchool", r)
                                }
                                defaultValue={formik.values.DateSchool}
                                label={("تاریخ ورود به مدرسه")}
                                error={
                                    Boolean(formik.errors.DateSchool)
                                }
                                portal
                                helperText={
                                    formik.errors.DateSchool
                                }
                                w={{xs: "100%", md: "100%", lg: "90%",}}

                                disabled={loading}
                            />
                        </Grid>
                        <Grid item xs={12} md={6} lg={3}>
                            <MDInput
                                id="ShomSkoonat"
                                name="ShomSkoonat"
                                value={formik.values.ShomSkoonat}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.ShomSkoonat)
                                }
                                helperText={formik.errors.ShomSkoonat}
                                autoComplete={"1"}
                                disabled={loading}
                                type={"number"}

                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "90%",}}}
                                label={"شماره محل سکونت"}/>
                        </Grid>
                        <Grid item xs={12} md={9} lg={9}>
                            <MDInput
                                id="AddressSkoonat"
                                name="AddressSkoonat"
                                value={formik.values.AddressSkoonat}
                                onChange={formik.handleChange}
                                error={
                                    Boolean(formik.errors.AddressSkoonat)
                                }
                                helperText={formik.errors.AddressSkoonat}
                                autoComplete={"1"}
                                disabled={loading}
                                width={"200px"}
                                sx={{width: {xs: "100%", md: "100%", lg: "97%",}}}
                                label={"آدرس محل سکونت"}/>
                        </Grid>
                    </>
                    }
                </Grid>
            </Grid>

            <Grid container my={5} justifyContent={"end"}>
                <Grid item xs={2} textAlign={"start"}>
                    <ButtonBase onClick={formik.handleSubmit}
                                sx={{background: "#4F2788", width: "100%", borderRadius: "5px", height: 50}}
                                disabled={loading}
                                type={"submit"}>
                        <MDBox width={"100%"} py={2}>
                            <MDTypography color={"white"} fontWeight={"bold"} fontSize={"20px"}>
                                ثبت
                            </MDTypography>
                        </MDBox>
                    </ButtonBase>

                </Grid>


            </Grid>

        </MDBox>
    </DashboardLayout>
}
